































































































































































































































import Vue from 'vue';
import {
  ButtonGroup,
  RecentActivity,
  AccountsOverview,
} from '@/components/account-components';
import { ThreeResourceBuckets } from '@/components/resources-components';
import { Alerts } from '@/components/alerts-component';
import { SubstantiationAlert, MigratedAlert } from '@/components/account-components';
import store from '@/store';
import { LoadingService, ExtendMixins } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import { AnnouncementBanner, AlertBanner } from '@/components/global-components';
import {
  MemberAccountResponseModel,
  CTA,
  UserModel,
} from '@/@types/member';
import moment from 'moment';
import { dateFormatYYYYMMDD, dateFormat } from '@/constants';

export default Vue.extend({
  name: 'Accounts',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getAccounts'),
      store.dispatch('getMemberRecentActivity'),
      getContentArea([
        'account-column-1',
        'account-column-2',
        'account-column-3',
        'announcement-banner-on-off-switch',
      ]),
    ];
    LoadingService.watchPromises(promises)
      .then((data) => {
        to.meta.announcement = data[2][3];
        to.meta.content = data[3];
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  beforeMount(): void {
    if (!this.$route.params.id_token) {
      this.$router.replace('/accounts');
    }
  },
  mounted() {
    EventBus.$on('hqySSO', () => {
      (this.$refs.specialSSOLinkBanner as any).getHealthEquitySSO(true);
    });
  },
  destroyed() {
    EventBus.$off('hqySSO');
  },
  computed: {
    buttons(): CTA[] {
      const buttonGroup: CTA[] = [];
      const getReimbursed: CTA = {
        to: {
          name: 'submitClaim',
          params: {step: '1', action: 'reimburse'},
        },
        text: this.$options.filters.t([
          'accounts-button-group_action_get-reimbursed',
          'global_get-reimbursed',
        ]),
        icon: 'icon-reimburse',
        cypressKey: 'get-reimbursed',
      };
      const makeDeposit: CTA = {
        to: {name: 'makeDeposit', params: {step: '1'}},
        text: this.$options.filters.t([
          'accounts-button-group_action_make-deposit',
          'global_make-deposit',
        ]),
        icon: 'icon-deposit',
        cypressKey: 'make-deposit',
      };
      const payBill: CTA = {
        to: {name: 'payBill', params: {step: '1', action: 'pay-bill'}},
        text: this.$options.filters.t([
          'accounts-button-group_action_pay-bill',
          'global_pay-bill',
        ]),
        icon: 'icon-pay_bill',
        cypressKey: 'pay-bill',
      };
      const manageCard: CTA = {
        to: {name: 'paymentMethod'},
        text: this.$options.filters.t([
          'accounts-button-group_action_manage-card',
          'global_manage-card',
        ]),
        icon: 'icon-manage_card',
        cypressKey: 'manage-card',
      };
      const manageBanking: CTA = {
        to: {name: 'bankAccounts'},
        text: this.$options.filters.t([
          'accounts-button-group_action_manage-banking',
          'global_manage-banking',
        ]),
        icon: 'icon-banking',
        cypressKey: 'manage-banking',
      };
      if (this.hasNonTRA && this.hasNonMigrated) {
        buttonGroup.push(getReimbursed);
      }
      if (this.hasActiveHSA && this.hasNonMigrated) {
        buttonGroup.push(makeDeposit);
      }
      if (this.hasNonTRAandAAP && this.hasNonMigrated) {
        buttonGroup.push(payBill);
      }
      if (this.hasAllowCards && this.hasNonMigrated) {
        buttonGroup.push(manageCard);
      }
      if (this.hasNonMigrated) {
        buttonGroup.push(manageBanking);
      }
      return buttonGroup;
    },
    hasActiveHSA(): boolean {
      return this.$store.getters.hasActiveHSA;
    },
    hasNonTRA(): boolean {
      return this.$store.getters.hasNonTRA;
    },
    hasNonTRAandAAP(): boolean {
      return this.$store.getters.hasNonTRAandAAP;
    },
    hasAllowCards(): boolean {
      return this.$store.getters.hasAllowCards;
    },
    hasNonMigrated(): boolean {
      return this.$store.getters.hasNonMigrated;
    },
    accounts(): MemberAccountResponseModel[] {
      return this.$store.getters.accounts;
    },
    inactiveAccounts(): MemberAccountResponseModel[] {
      return this.$store.getters.inactiveAccounts;
    },
    // TODO Set up type
    alerts(): any {
      return this.$store.getters.alerts;
    },
    user(): UserModel {
      return this.$store.getters.user;
    },
    hiaMigrationWaveDate(): string {
      return moment(this.user.hiaMigrationWaveStartDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    migrationWaveDate(): string {
      return moment(this.user.migrationDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    yearOfMigrationWaveDate(): string {
      return this.user.migrationDate ? this.user.migrationDate.substring(0, 4) : '';
    },
    blackoutStartDate(): string {
      return moment(this.user.blackoutStartDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    hiaBlackoutStartDate(): string {
      return moment(this.user.hiaBlackoutStartDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    memberMicrosite(): string {
      if (!this.user.memberMicrosite) {
        return '';
      }
      return this.user.memberMicrosite.startsWith('http') ? this.user.memberMicrosite : `https://${this.user.memberMicrosite}`;
    },
    fsaPriorPyStartDate(): string {
      return moment(this.user.fsaPriorPYStartDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    fsaPriorPyEndDate(): string {
      return moment(this.user.fsaPriorPYEndDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    hraPriorPyStartDate(): string {
      return moment(this.user.hraPriorPYStartDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    hraPriorPyEndDate(): string {
      return moment(this.user.hraPriorPYEndDate, dateFormatYYYYMMDD).format(dateFormat);
    },
    fsaTransitionClaimText(): string {
      const fsaPriorPyStartDate = this.fsaPriorPyStartDate;
      const fsaPriorPyEndDate = this.fsaPriorPyEndDate;
      const migrationWaveDate = this.migrationWaveDate;
      const replacementVars = {
        fsaPriorPyStartDate,
        fsaPriorPyEndDate,
        migrationWaveDate,
      };
      return this.user.fsaClaimIndicator ? this.$options.filters!.varReplace(this.$options.filters!.t('fsa-transition-banner-claim-text'), replacementVars) : '';
    },
    fsaTransitionRolloverText(): string {
      return this.user.fsaRolloverInd ? this.$options.filters!.t('fsa-transition-banner-rollover-text') : '';
    },
    hraTransitionClaimText(): string {
      const hraPriorPyStartDate = this.hraPriorPyStartDate;
      const hraPriorPyEndDate = this.hraPriorPyEndDate;
      const migrationWaveDate = this.migrationWaveDate;
      const replacementVars = {
        hraPriorPyStartDate,
        hraPriorPyEndDate,
        migrationWaveDate,
      };
      return this.user.hraClaimIndicator ? this.$options.filters!.varReplace(this.$options.filters!.t('hra-transition-banner-claim-text'), replacementVars) : '';
    },
    hraTransitionRolloverText(): string {
      return this.user.hraRolloverInd ? this.$options.filters!.t('hra-transition-banner-rollover-text') : '';
    },
    hqySSOLink(): string {
      return this.user.hqySsoInd ? this.$options.filters!.t('hqy-sso-link-markdown') : this.$options.filters!.t('hqy-no-sso-link');
    },
    showAnnouncement(): any {
      return this.$route.meta.announcement.fields.showhide && this.$store.getters.showAnnouncement;
    },
    showBlackoutBanner(): boolean {
      // MBR-015 BR-1.03 – If the [In Blackout Indicator] tag from UC-REST-002 is equal to true and the [Bulk Transfer Indicator] is equal to true,
      // the System will display the Blackout banner at the top of the screen:
      return this.user.inBlackoutInd && this.user.bulkTransferInd;
    },
    isHSATransition(): boolean {
      return this.user.hasHSAInd && !this.user.bulkTransferInd && !!this.user.journeyStartDate && !!this.user.migrationDate;
    },
    showHSATransitionBanner(): boolean {
      // MBR-015 - BR-1.03.a – HSA Notice of Transition – Non-CareFirst. The System will display the HSA Notice of Transition banner at the top of the screen for a member where the the
      // [CareFirst Member Indicator] is equal to false and the [Horizon Member Indicator] is equal to false and
      // [Migr HSA Indicator] tag from UC-REST-002 is equal to true and the [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null and the [Bulk Transfer Indicator] is equal to false.
      // This banner will display starting on the [Journey Start Date] and will run until the day prior to the [Blackout Start Date].
      return !this.user.careFirstMemberInd && !this.user.horizonMemberInd && this.isHSATransition && moment().isBetween(
        moment(this.user.journeyStartDate, dateFormatYYYYMMDD),
        moment(this.user.blackoutStartDate, dateFormatYYYYMMDD),
        'day',
        '[)',
      );
    },
    showHSABlackoutBanner(): boolean {
      // MBR-015 - BR-1.03.b – HSA Notice of Blackout – Non-CareFirst. The System will display the HSA Notice of Blackout banner at the top of the screen for a member where the the
      // [CareFirst Member Indicator] is equal to false and the [Horizon Member Indicator] is equal to false and
      // [Has HSA Indicator] tag from UC-REST-002 is equal to true and the [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null and the [Bulk Transfer Indicator] is equal to false.
      // This banner will display starting on the [Blackout Start Date] and will run until the day prior to the [Migration Wave Date].
      return !this.user.careFirstMemberInd && !this.user.horizonMemberInd && this.isHSATransition && moment().isBetween(
        moment(this.user.blackoutStartDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        'day',
        '[)',
      );
    },
    showHSATransitionCompleteBanner(): boolean {
      // MBR-015 - BR-1.03.c – HSA Notice of Transition Complete – Non-CareFirst. The System will display the HSA Notice of Transition Complete banner at the top of the screen for a member the
      // [CareFirst Member Indicator] is equal to false and the [Horizon Member Indicator] is equal to false and
      // where the [Has HSA Indicator] tag from UC-REST-002 is equal to true and the [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null and the [Bulk Transfer Indicator] is equal to false.
      // This banner will display starting on the [Migration Wave Date] and will run until the current date is six months after the [Migration Wave Date].
      return !this.user.careFirstMemberInd && !this.user.horizonMemberInd && this.isHSATransition && moment().isBetween(
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD).add(6, 'months'),
        'day',
        '[]',
      );
    },
    isCarefirstTransition(): boolean {
      return (this.user.hasHSAInd || this.user.hasFSAInd || this.user.hasHRAInd) && !this.user.bulkTransferInd && !!this.user.journeyStartDate && !!this.user.migrationDate;
    },
    showTransitionBannerCarefirst(): boolean {
      // MBR-015 BR-1.03.d – Notice of Transition – CareFirst . The System will display the Notice of Transition banner at the top of the screen for a member where all the following are true:
      // The [CareFirst Member Indicator] is equal to true
      // The [Has HSA Indicator] tag from UC-REST-002 is equal to true or the [Has FSA Indicator] tag from UC-REST-002 is equal to true or the [Has HRA Indicator] tag from UC-REST-002 is equal to true
      // The [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null
      // The [Bulk Transfer Indicator] is equal to false
      return this.user.careFirstMemberInd && this.isCarefirstTransition && moment().isBetween(
        moment(this.user.journeyStartDate, dateFormatYYYYMMDD),
        moment(this.user.blackoutStartDate, dateFormatYYYYMMDD),
        'day',
        '[)',
      );
    },
    showBlackoutBannerCarefirst(): boolean {
      // MBR-015 - BR-1.03.e – Notice of Blackout – CareFirst . The System will display the Notice of Blackout banner at the top of the screen for a member where all the following are true:
      // The [CareFirst Member Indicator] is equal to true
      // The [Has HSA Indicator] tag from UC-REST-002 is equal to true or the [Has FSA Indicator] tag from UC-REST-002 is equal to true or the [Has HRA Indicator] tag from UC-REST-002 is equal to true
      // The [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null
      // The [Bulk Transfer Indicator] is equal to false
      return this.user.careFirstMemberInd && this.isCarefirstTransition && moment().isBetween(
        moment(this.user.blackoutStartDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        'day',
        '[)',
      );
    },
    showTransitionCompleteBannerCarefirst(): boolean {
      // MBR-015 - BR-1.03.f – Notice of Transition Complete – CareFirst . The System will display the Notice of Transition Complete banner at the top of the screen for a member where all the following are true:
      // The [CareFirst Member Indicator] is equal to true
      // The [Has HSA Indicator] tag from UC-REST-002 is equal to true or the [Has FSA Indicator] tag from UC-REST-002 is equal to true or the [Has HRA Indicator] tag from UC-REST-002 is equal to true
      // The [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null
      // The [Bulk Transfer Indicator] is equal to false
      return  this.user.careFirstMemberInd && this.isCarefirstTransition && moment().isBetween(
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD).add(6, 'months'),
        'day',
        '[]',
      );
    },
    showFSATransitionBanner(): boolean {
      // MBR-015 - BR-1.04.a – FSA Notice of Transition - Non-CareFirst. The System will display the FSA Notice of Transition banner at the top of the screen for a member where the [CareFirst Member Indicator] is equal to false and
      // [Has FSA Indicator] tag from UC-REST-002 is equal to true and the [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null.
      // This banner will display starting on the [Migration Wave Date] and will run until the current date is six months after the [Migration Wave Date].
      return  !this.user.careFirstMemberInd && this.user.hasFSAInd && this.user.journeyStartDate && this.user.migrationDate && moment().isBetween(
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD).add(6, 'months'),
        'day',
        '[]',
      );
    },
    showHRATransitionBanner(): boolean {
      // MBR-015 - BR-1.04.b – HRA Notice of Transition - Non-CareFirst. The System will display the HRA Notice of Transition banner at the top of the screen for a member where the [CareFirst Member Indicator] is equal to false and
      // [Has HRA Indicator] tag from UC-REST-002 is equal to true and the [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null.
      // This banner will display starting on the [Migration Wave Date] and will run until the current date is six months after the [Migration Wave Date].
      return  !this.user.careFirstMemberInd && this.user.hasHRAInd && this.user.journeyStartDate && this.user.migrationDate && moment().isBetween(
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD).add(6, 'months'),
        'day',
        '[]',
      );
    },
    isHIATransition(): boolean {
      return (this.user.hasHIAInd && !!this.user.hiaJourneyStartDate);
    },
    showHIATransitionBannerCarefirst(): boolean {
      // MBR-015 - BR-1.05.a – CareFirst HIA Notice of Transition . The System will display the Notice of Transition banner at the top of the screen for a member where the [Has HIA Indicator] tag from UC-REST-002 is equal to true
      // and the [HIA Journey Start Date] tag from UC-REST-002 is not null. This banner will display starting on the [HIA Journey Start Date] and will run until the day prior to the [HIA Blackout Start Date].
      // Note: the [Member Microsite] should display as a link to the microsite URL.
      return this.isHIATransition && moment().isBetween(
          moment(this.user.hiaJourneyStartDate, dateFormatYYYYMMDD),
          moment(this.user.hiaBlackoutStartDate, dateFormatYYYYMMDD),
          'day',
          '[)',
        );
    },
    showHIABlackoutBannerCarefirst(): boolean {
      // MBR-015 - BR-1.05.b – CareFirst HIA Notice of Blackout . The System will display the Notice of Blackout banner at the top of the screen for a member where the [Has HIA Indicator] tag from UC-REST-002 is equal to true
      // and the [HIA Journey Start Date] tag from UC-REST-002 is not null. This banner will display starting on the [HIA Blackout Start Date] and will run until the day prior to the [HIA Migration Wave Date].
      // Note: the text “access your account” will be an SSO link to the HQY member portal and will only display if the [HQY SSO Indicator] tag from UC-REST-002 is equal to true.
      return this.isHIATransition && moment().isBetween(
          moment(this.user.hiaBlackoutStartDate, dateFormatYYYYMMDD),
          moment(this.user.hiaMigrationWaveStartDate, dateFormatYYYYMMDD),
          'day',
          '[)',
        );
    },
    showHIATransitionCompleteBannerCarefirst(): boolean {
      // MBR-015 - BR-1.05.c – CareFirst HIA Notice of Transition Complete . The System will display the Notice of Transition Complete banner at the top of the screen for a member where the [Has HIA Indicator] tag from UC-REST-002 is equal to true
      // and the [HIA Journey Start Date] tag from UC-REST-002 is not null. This banner will display starting on the [HIA Migration Wave Date] and will run until the current date is one month after the greater of [9/1/2026 and the [HIA Migration Wave Date]].
      // Note: the Visit Portal button will only display if the [HQY SSO Indicator] tag from UC-REST-002 is equal to true.
      return this.isHIATransition && moment().isBetween(
        moment(this.user.hiaMigrationWaveStartDate, dateFormatYYYYMMDD),
        moment.max(moment('2026-09-01', dateFormatYYYYMMDD), moment(this.user.hiaMigrationWaveStartDate, dateFormatYYYYMMDD)).add(1, 'months'),
        'day',
        '[]',
      );
    },
    showHIAMigratedNoticeCarefirst(): boolean {
      // BR-1.05.d – CareFirst Migrated HIA Notice. The System will display the Migrated HIA banner at the top of the screen for a member where the [Has Migrated HIA] tag from UC-REST-002 is equal to true.
      return this.user.hasMigratedHIAInd;
    },
    isMidYearTransition(): boolean {
      return ((this.user.hasFSAInd && this.user.fsaBlackoutStartDate) || (this.user.hasHRAInd && this.user.hraBlackoutStartDate)) &&
        this.user.journeyStartDate && this.user.migrationDate && !this.user.bulkTransferInd;
    },
    showRAMidyearTransitionNotice(): boolean {
      // BR-1.06.a – RA Midyear Notice of Transition – Non-CareFirst. The System will display the RA Midyear Notice of Transition banner at the top of the screen for a member where:
      // The [CareFirst Member Indicator] tag from UC-REST-002 is equal to false
      // The [Horizon Member Indicator] tag from UC-REST-002 is equal to false
      // The {[Has FSA Indicator] tag from UC-REST-002 is equal to true and the [FSA Blackout Start Date] tag from UC-REST-002 is not null} or {the [Has HRA Indicator] tag from UC-REST-002 is equal to true and the [HRA Blackout Start Date] tag from UC-REST-002 is not null} and
      // The [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null and
      // The [Bulk Transfer Indicator] is equal to false.
      // This banner will display starting on the [Journey Start Date] and will run until the day prior to the [Blackout Start Date].
      return !this.user.careFirstMemberInd && !this.user.horizonMemberInd && this.isMidYearTransition && moment().isBetween(
          moment(this.user.journeyStartDate, dateFormatYYYYMMDD),
          moment(this.user.blackoutStartDate, dateFormatYYYYMMDD),
          'day',
          '[)',
        );
    },
    showRAMidyearBlackoutNotice(): boolean {
      // BR-1.06.b – RA Midyear Notice of Blackout – Non-CareFirst. The System will display the RA Midyear Notice of Blackout banner at the top of the screen for a member where:
      // The [CareFirst Member Indicator] tag from UC-REST-002 is equal to false
      // The [Horizon Member Indicator] tag from UC-REST-002 is equal to false
      // The {[Has FSA Indicator] tag from UC-REST-002 is equal to true and the [FSA Blackout Start Date] tag from UC-REST-002 is not null} or {the [Has HRA Indicator] tag from UC-REST-002 is equal to true and the [HRA Blackout Start Date] tag from UC-REST-002 is not null} and
      // The [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null and
      // The [Bulk Transfer Indicator] is equal to false.
      // This banner will display starting on the [Blackout Start Date] and will run until the day prior to the [Migration Wave Date].
      return !this.user.careFirstMemberInd && !this.user.horizonMemberInd && this.isMidYearTransition && moment().isBetween(
          moment(this.user.blackoutStartDate, dateFormatYYYYMMDD),
          moment(this.user.migrationDate, dateFormatYYYYMMDD),
          'day',
          '[)',
        );
    },
    showRAMidyearTransitionComplete(): boolean {
      // BR-1.06.c – RA Midyear Notice of Transition Complete – Non-CareFirst. The System will display the RA Midyear Notice of Transition Complete banner at the top of the screen for a member where:
      // // The [CareFirst Member Indicator] tag from UC-REST-002 is equal to false
      // The [Horizon Member Indicator] tag from UC-REST-002 is equal to false
      // The {[Has FSA Indicator] tag from UC-REST-002 is equal to true and the [FSA Blackout Start Date] tag from UC-REST-002 is not null} or {the [Has HRA Indicator] tag from UC-REST-002 is equal to true and the [HRA Blackout Start Date] tag from UC-REST-002 is not null}and
      // The [Journey Start Date] and the [Migration Wave Date] tags from UC-REST-002 are not null and
      // The [Bulk Transfer Indicator] is equal to false.
      // This banner will display starting on the [Migration Wave Date] and will run until the current date is six months after the [Migration Wave Date].
      return !this.user.careFirstMemberInd && !this.user.horizonMemberInd && this.isMidYearTransition && moment().isBetween(
        moment(this.user.migrationDate, dateFormatYYYYMMDD),
        moment(this.user.migrationDate, dateFormatYYYYMMDD).add(6, 'months'),
        'day',
        '[]',
      );
    },
    showIWantTo(): boolean {
      return this.buttons.length > 0;
    },
    showCityOfMplsBanner(): boolean {
      return this.user.groupKey === '43156';
    },
    // BR-1.03.g – Notice of Transition – Horizon. The System will display the Horizon Notice of Transition banner at the top of the screen for a member
    // where the [Has Horizon Account Indicator] is equal to true and the [Bulk Transfer Indicator] is equal to false. This banner will display starting
    // on 6/1/2026 and will run through 6/30/2026.
    showHorizonNoticeOfTransition(): boolean {
      return this.user.hasHorizonAccountInd && !this.user.bulkTransferInd && moment().isBetween(
        moment('2026-06-01', dateFormatYYYYMMDD),
        moment('2026-06-30', dateFormatYYYYMMDD),
        'day',
        '[]',
      );
    },
  },
  components: {
    ButtonGroup,
    RecentActivity,
    ThreeResourceBuckets,
    AccountsOverview,
    Alerts,
    SubstantiationAlert,
    AnnouncementBanner,
    AlertBanner,
    MigratedAlert,
  },
});
